export enum AdvanceInvoiceOptionEnums {
  notCalculateDifference = 1,
  calculateDifferenceNotInvoice = 2,
  calculateDifferenceAndInvoice = 3
}